export enum APPLICATION_STATUS {
  SUBMITTED = "SUBMITTED",
  PENDING = "PENDING",
  ON_VIEW = "ON_VIEW",
  SHORT_LISTED = "SHORT_LISTED",
  REJECTED = "REJECTED",
  SAVED = "SAVED",
  APPROVED = "APPROVED",
}
